export const textMap = [
  { label: '搜索词', value: 'replace.searchKeyWord' },
  { label: '当前页面标题', value: 'replace.documentTitle' }
];
